import { Box, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import Price from '../../../../../../../common/components/presentation/Price';
import priceWithLabelStyles from './priceWithLabelStyles';

export interface IPriceWithLabel {
  price: IPrice;
  decimalScale?: number;
  label: JSX.Element | string;
  loading?: boolean;
}

const PriceWithLabel: FunctionComponent<IPriceWithLabel> = ({ price, decimalScale, label, loading }) => {
  const style = priceWithLabelStyles();

  return (
    <Box display="flex" flexDirection="column" justifyContent={'center'} alignItems={'center'}>
      <Price
        data-test={'text:price:total'}
        price={price?.basePrice}
        decimals={decimalScale}
        currency={price?.currency}
        className={style.price}
        loading={loading}
      />
      <Typography className={style.label} variant={'helpingText'} data-test={'text:price:label'}>
        {label}
      </Typography>
    </Box>
  );
};

export default PriceWithLabel;
